import * as React from "react";
import PropTypes from 'prop-types';

const SvgStarFilled = props => {
  if (props.id !== "_svgstarfilled") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 34 34" fill="none" {...props}><path d="M20.111 13.54c.21.494.675.832 1.21.879l8.015.695-6.063 5.258a1.45 1.45 0 00-.463 1.422l1.807 7.814-7.23-4.36-.387-.234-.388.233-7.23 4.36 1.808-7.813a1.45 1.45 0 00-.463-1.422l-6.064-5.258 8.015-.695a1.45 1.45 0 001.21-.88l3.111-7.363 3.112 7.363z" stroke="#E71324" strokeWidth={1.5} /></svg>;
};

SvgStarFilled.displayName = "_svgstarfilled";
SvgStarFilled.propTypes = {
  id: PropTypes.string
};
SvgStarFilled.defaultProps = {
  id: ''
};
export default SvgStarFilled;